import { useState } from "react";
import ChoiceCard from "./ChoiceCard";
import "./v2-question-surface.css";

export default function ChoiceStack({
  options,
  value,
  behavior = "single-select",
  autoAdvance = false,
  max,
  ariaLabel = "Choice options",
  onChange,
  onAutoAdvance,
}) {
  const [bloomingKey, setBloomingKey] = useState(null);
  const [nudgingKey, setNudgingKey] = useState(null);
  const [limitMessage, setLimitMessage] = useState("");
  const isMultiSelect = behavior === "multi-select";
  const selectedValues = isMultiSelect ? (Array.isArray(value) ? value : []) : [];
  const selectedCount = selectedValues.length;

  const handleSelect = (option) => {
    if (isMultiSelect) {
      const selected = selectedValues.includes(option.key);
      if (!selected && max && selectedCount >= max) {
        setNudgingKey(option.key);
        setLimitMessage(`Pick up to ${max}. Deselect one to choose another.`);
        window.setTimeout(() => {
          setNudgingKey((current) => (current === option.key ? null : current));
        }, 180);
        window.setTimeout(() => setLimitMessage(""), 1800);
        return;
      }

      const nextValue = selected
        ? selectedValues.filter((key) => key !== option.key)
        : [...selectedValues, option.key];

      setBloomingKey(option.key);
      onChange(nextValue);

      window.setTimeout(() => {
        setBloomingKey((current) => (current === option.key ? null : current));
      }, 300);
      return;
    }

    setBloomingKey(option.key);
    onChange(option.key);

    window.setTimeout(() => {
      setBloomingKey((current) => (current === option.key ? null : current));
    }, 300);

    if (behavior === "single-select" && autoAdvance) {
      window.setTimeout(() => {
        onAutoAdvance?.(option.key);
      }, 400);
    }
  };

  return (
    <div
      className="tgc-v2-choice-stack"
      role="group"
      aria-label={isMultiSelect && max ? `${ariaLabel}. Pick up to ${max}.` : ariaLabel}
    >
      {options.map((option) => (
        <ChoiceCard
          key={option.key}
          title={option.title}
          explanation={option.explanation}
          selected={isMultiSelect ? selectedValues.includes(option.key) : value === option.key}
          blooming={bloomingKey === option.key}
          unavailable={isMultiSelect && max && selectedCount >= max && !selectedValues.includes(option.key)}
          nudging={nudgingKey === option.key}
          onSelect={() => handleSelect(option)}
        />
      ))}
      <div className="tgc-v2-choice-limit-status" aria-live="polite">
        {limitMessage}
      </div>
    </div>
  );
}
